import icon from '../resource/ma_icon.png';
import {ConfigProvider, Drawer, Menu} from 'antd';
import {useState} from 'react';
import {AiOutlineMenu} from 'react-icons/ai';
import {useNavigate} from 'react-router-dom';

export default function MyHeader() {
  
  const navigate = useNavigate();
  const [currentMenu, setCurrentMenu] = useState('/about');
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  
  const menuItems = [
    {
      label: '关于我们',
      key: 'about',
    },
    {
      label: '投资理念',
      key: 'idea',
    },
    {
      label: '投资领域',
      key: 'area',
    },
    {
      label: '投资案例',
      key: 'case',
    },
    {
      label: '企业新闻',
      key: 'news',
    },
    {
      label: '联系我们',
      key: 'contact',
    },
  ];
  
  const handleChangeMenu = (e) => {
    setCurrentMenu(e.key);
    const targetElement = document.getElementById(e.key);
    if (targetElement) {
      if (e.key === 'contact') {
        window.scrollTo(0, document.body.scrollHeight);
        window.scrollTo(0, document.body.scrollHeight);
      } else {
        targetElement.scrollIntoView();
        const height = window.scrollY;
        window.scroll(0, height - 100);
      }
    } else {
      navigate(`/#${e.key}`);
    }
    setIsSideMenuOpen(false);
  };
  
  const handleCloseSideMenu = () => {
    setIsSideMenuOpen(false);
  };
  
  const handleOpenSideMenu = () => {
    setIsSideMenuOpen(true);
  };
  
  return (
    <div className="home-header">
      <img
        className="header-logo"
        src={icon}
        alt="Morning Alliance"
        onClick={() => {
          if (window.location.pathname === '/') {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          } else {
            navigate('/');
          }
        }}
      />
      <Menu
        className="home-menu"
        onClick={handleChangeMenu}
        selectedKeys={[currentMenu]}
        mode="horizontal"
        items={menuItems}
        overflowedIndicator={
          <div className="home-menu-overflow-icon"><AiOutlineMenu size={32}/></div>
        }
      />
      <div className="home-menu-collapse-btn" onClick={handleOpenSideMenu}>
        <div className="home-menu-overflow-icon"><AiOutlineMenu size={32}/></div>
      </div>
      <Drawer
        open={isSideMenuOpen}
        onClose={handleCloseSideMenu}
        width={180}
        styles={{
          body: {
            padding: 0,
          }
        }}
      >
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                colorPrimary: '#001B5B',
                fontSize: 20,
                itemHeight: 48
              },
            },
          }}
        >
          <Menu
            onClick={handleChangeMenu}
            selectedKeys={[currentMenu]}
            mode="inline"
            items={menuItems}
          />
        </ConfigProvider>
      </Drawer>
    </div>
  );
}